import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN
import {
  Avatar,
  Button,
  List,
  Divider,
  Modal,
  Upload,
  Col,
  Form,
  Spin,
  Select,
  Typography,
} from "antd";
import {
  DownloadOutlined,
  DeleteOutlined,
  FilePdfOutlined,
  FileImageOutlined,
  PlusCircleOutlined,
  UploadOutlined,
  EyeOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { useNavigate } from "react-router-dom";
import { showCheckerApprovalModal } from "../../../../../components/CheckerModal";
import appConfig from "../../../../../config/appConfig";
import axios from "axios";

const Document = (props) => {
  const { currentCustomerObj, userData } = props;
  const { session } = userData;
  const [isLoading, setIsLoading] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    BOM.HasPermission("READ_DOCUMENT") && getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}/documents`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempArray = [];

        objList
          // ?.filter((item) => item.name?.toLowerCase() !== "clientsignature")
          .forEach((element) => {
            tempArray.push({
              id: element?.id,
              title: element?.name,
              description: element?.fileName,
              type: element.type,
            });
          });

        setDocumentData(tempArray);
        setIsLoading(false);
      }
    });
  };

  

  const handleOnDelete = (key) => {
    // console.log(key);
    let action = "Delete  ";
    let label = key.title;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${apiConfig.Clients}/${currentCustomerObj.id}/documents/${key.id}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteDocumentMsg);

              //update list
              getDetailById();

              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              // navigate(0);
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };

  const onFileTypeCheck = (objParam) => {
    switch (objParam.type.toLowerCase()) {
      case "application/pdf":
        return false;
      default:
        return true;
    }
  };

  const handleDownload = async (item) => {
    // try {
    const url = `${apiConfig.Clients}/${currentCustomerObj.id}/documents/${item.id}/attachment?tenantIdentifier=default`;
    const body = {
      method: "GET",
      session,

      responseType: "blob",
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        // BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteDocumentMsg);
        console.log(res, "res");
        // Create a blob URL and trigger download
        const blob = new Blob([res.data]);
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = item.description || item.title || "document";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        //update list
        getDetailById();

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const handleDownload2 = async (item) => {
    try {
      const url = `${apiConfig.Clients}/${currentCustomerObj.id}/documents/${item.id}/attachment?tenantIdentifier=default`;

      const { headers } = appConfig.apiSettings;
      headers.Authorization = session;

      const tfaToken = localStorage.getItem("tfaToken");
      if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
        headers["Fineract-Platform-TFA-Token"] = tfaToken;
      } else {
        delete headers["Fineract-Platform-TFA-Token"];
      }

      const response = await axios({
        method: "GET",
        url: url,
        headers: headers,
        responseType: "blob",
      });

      console.log(response.data, "response");

      // Create a blob URL and trigger download
      const blob = new Blob([response.data]);
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = item.description || item.title || "document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
      if (error.response) {
        BOM.AlertMsg(
          cnt.DANGER,
          error.response.data?.defaultUserMessage || "Failed to download document"
        );
      } else {
        BOM.AlertMsg(cnt.DANGER, "Failed to download document");
      }
    }
  };
  return (
    <div
      id="scrollableDiv"
      style={{
        height: 300,
        overflow: "auto",
        padding: "16px",
      }}
    >
      <Spin spinning={isLoading} tip="Loading..." size="large">
        {BOM.HasPermission("CREATE_DOCUMENT") && (
          <DocumentModal
            currentCustomerObj={currentCustomerObj}
            userData={userData}
            getDocData={getDetailById}
          />
        )}
        <Divider style={{ marginTop: 10, marginBottom: 30 }} />
        <List
          itemLayout="horizontal"
          dataSource={documentData}
          renderItem={(item, index) => (
            <List.Item
              actions={[
                <Button
                  type="primary"
                  onClick={() => handleDownload2(item)}
                  shape="round"
                  size="small"
                  icon={<DownloadOutlined />}
                >
                  Download
                </Button>,
                //    <Button
                //    type="primary"
                //    // target="_blank"
                //    href={`${apiConfig.Clients}/${currentCustomerObj.id}/documents/${item.id}/attachment?tenantIdentifier=default`}
                //    shape="round"
                //    size="small"
                //    icon={<DownloadOutlined />}
                //    download={item.title}
                //  >
                //    Download
                //  </Button>,
                BOM.HasPermission("DELETE_DOCUMENT") && (
                  <Button
                    type="primary"
                    danger
                    shape="round"
                    size="small"
                    onClick={() => handleOnDelete(item)}
                    icon={<DeleteOutlined />}
                  >
                    Remove
                  </Button>
                ),
              ]}
            >
              <List.Item.Meta
                avatar={
                  <Avatar
                    style={{ fontSize: 25 }}
                    icon={
                      onFileTypeCheck(item) ? (
                        <FileImageOutlined style={{ fontSize: 25, color: "green" }} />
                      ) : (
                        <FilePdfOutlined style={{ fontSize: 25, color: "red" }} />
                      )
                    }
                  />
                }
                title={item.title}
                description={item.description}
              />
            </List.Item>
          )}
        />
      </Spin>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(Document);

const DocumentModal = (props) => {
  const { currentCustomerObj, userData, getDocData } = props;
  const { session } = userData;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [useForm] = Form.useForm();
  const docTypeName = Form.useWatch("name", useForm);
  const navigate = useNavigate();
  const [documentTypeData, setDocumentTypeData] = useState([]);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };
  console.log(docTypeName);

  const handleUpload = () => {
    if (!selectedFile) {
      BOM.AlertMsg(cnt.DANGER, "Please select a PDF file!");
      return;
    }

    if (selectedFile.type !== "application/pdf") {
      BOM.AlertMsg(cnt.DANGER, "Only PDF files are allowed!");
      return;
    }

    if (selectedFile.size / 1024 / 1024 > 5) {
      BOM.AlertMsg(cnt.DANGER, "File size must be less than 5MB!");
      return;
    }

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}/documents`;

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("name", docTypeName);

    // Attach session and method so FetchReqAction can read them
    formData.session = session;
    formData.method = "POST";

    setIsLoading(true);

    BOM.FetchReqAction(
      formData,
      url,
      (err, res) => {
        setIsLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Document uploaded successfully!");
          getDocData();
          setIsModalOpen(false);
          setSelectedFile(null);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate(0);
          setIsLoading(false);
        },
      }
    );
  };

  const getDocumentType = () => {
    setIsLoading(true);

    const url = `${apiConfig.Codes}/DocumentType/codevalues/byCodeName`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempArray = [];

        objList
          // ?.filter((item) => item.name?.toLowerCase() !== "clientsignature")
          .forEach((element) => {
            tempArray.push({
              value: element?.id,
              label: element?.name,
            });
          });

        setDocumentTypeData(tempArray);
        setIsLoading(false);
      }
    });
  };

  React.useEffect(() => {
    getDocumentType();
  }, []);
  return (
    <>
      <Button type="primary" shape="round" className="of-primaryBtnColor" onClick={showModal}>
        <PlusCircleOutlined />
        &nbsp;{labelConfig.upload}
      </Button>

      <Modal title="Document Upload Setup" open={isModalOpen} footer={null} onCancel={handleCancel}>
        <Spin spinning={isLoading} tip="Uploading..." size="large">
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              name: staticConfig.documentTypeData[1].value,
            }}
          >
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.documentType}
                name="name"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.documentType),
                  },
                ]}
              >
                <Select
                  placeholder={BOM.handlePlaceholderMsg(`${labelConfig.documentType} *`, "select")}
                  options={documentTypeData}
                  // options={staticConfig.documentTypeData}
                  showSearch
                />
              </Form.Item>
            </Col>

            <Divider orientation="left" orientationMargin="0">
              Please select document
            </Divider>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Typography style={{ marginBottom: 5, color: "red", fontStyle: "italic" }}>
                *Max file size 5MB
              </Typography>
              <input
                type="file"
                accept="application/pdf"
                style={{ display: "none" }}
                id="fileInput"
                onChange={handleFileChange}
              />
              <Button
                type="dashed"
                onClick={() => document.getElementById("fileInput").click()}
                icon={<UploadOutlined />}
              >
                Select PDF
              </Button>

              {selectedFile && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 12,
                    padding: 8,
                    border: "1px solid #d9d9d9",
                    borderRadius: 6,
                    background: "#fafafa",
                  }}
                >
                  <FilePdfOutlined style={{ fontSize: 24, color: "#f5222d", marginRight: 12 }} />
                  <div style={{ flexGrow: 1 }}>
                    <Typography.Text strong>{selectedFile.name}</Typography.Text>
                    <br />
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                      {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                    </Typography.Text>
                  </div>
                  <Button
                    type="text"
                    danger
                    onClick={() => setSelectedFile(null)}
                    style={{ marginLeft: 8 }}
                  >
                    Remove
                  </Button>
                </div>
              )}

              <Button
                type="primary"
                icon={<UploadOutlined />}
                style={{ marginTop: 12 }}
                onClick={handleUpload}
                disabled={!selectedFile} // prevent upload without a file
                className="of-primaryBtnColor"
              >
                Upload
              </Button>
            </Col>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};
